import { createTheme } from '@material-ui/core/styles';
import { colorBlue1, colorGrey0 } from 'styles/_colors.scss';

export const options = itemLength => {
    return {
        filtering: false,
        search: false,
        sorting: false,
        draggable: false,
        showTitle: false,
        toolbar: false,
        emptyRowsWhenPaging: false,
        tableLayout: 'fixed',
        paging: (itemLength > 10),
        pageSize: 10,
        pageSizeOptions: [10],
        actionsColumnIndex: -1,
    };
};

export const columns =
    [
        {
            title: 'Name',
            field: 'name',
            width: '350px'
        },
        {
            title: 'PI',
            field: 'principalInvestigator',
            width: '150px'
        },
        {
            title: 'Site',
            field: 'site',
            width: '150px'
        },
        {
            title: '',
            width: '25px',
        }
    ];

export const theme = createTheme({
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontFamily: 'Hind',
                fontSize: '14px',
                fontWeight: 500,
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: '1.29'
            }
        },
        MuiPaper: {
            root: {
                width: '100%',
                margin: '0 auto',
                boxShadow: 'none !important',
            }
        },
        MuiTable: {
            root: {
                width: '100%',
                margin: '0 !important',
                border: '0px solid gray',
            }
        },
        MuiTableRow: {
            root: {
                margin: '0px 6px',
            },
        },
        MuiTableCell: {
            root: {
                padding: '0 6px !important',
                borderBottom: '0.5px solid gray',
                minHeight: '52px',
                height: '32px !important',
                lineHeight: '1',
                maxWidth: '450px',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            },
            head: {
                fontFamily: 'Hind',
                fontSize: '16px',
                fontWeight: 700,
                color: '#556677',
            },
            body: {
                fontFamily: 'Hind !important',
                fontSize: '16px !important',
                fontWeight: '500 !important',
                color: `${colorGrey0} !important`
            }
        },
        MuiTableFooter: {
            root: {
                justifyContent: 'center',
            }
        },
        MuiSvgIcon: {
            root: {
                color: colorBlue1,
            },
        },
        MuiIconButton: {
            root: {
                border: 'none',
                '&:focus': {
                    boxShadow: 'none',
                    color: colorBlue1
                },
                '&:hover': {
                    color: colorBlue1
                }
            },
        },
    }
});
